if (document.readyState !== 'loading') {
    initializeMap();
} else {
    document.addEventListener('DOMContentLoaded', function (event) {
        initializeMap();
    });
}

function initializeMap() {
    if (typeof mapboxgl !== 'undefined') {
        mapboxgl.accessToken = 'pk.eyJ1IjoiY3ViZXRlY2giLCJhIjoiNXNzUHdfbyJ9.tm-Kh0sz67FPbXgoKofkwQ';
        const mapElements = document.querySelectorAll('.ct_map .mapbox');

        if (mapElements.length < 1) {
            return;
        }

        const maps = [];
        mapElements.forEach((mapItem) => {
            // Map initialization
            const mapId = mapItem.children[0].id;
            const longitude = mapItem.dataset.lng;
            const latitude = mapItem.dataset.lat;
            const style = mapItem.dataset.style;
            const zoom = mapItem.dataset.zoom;
            const map = new mapboxgl.Map({
                container: mapId,
                style: style ? style : 'mapbox://styles/mapbox/streets-v11',
                center: [longitude, latitude],
                zoom: zoom,
                minZoom: 7,
                maxZoom: 18,
            });

            // Marker coordination
            const geojson = {
                type: 'FeatureCollection',
                features: [
                    {
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: [longitude, latitude],
                        },
                    },
                ],
            };

            // Marker initialization
            geojson.features.forEach((marker) => {
                const el = document.createElement('span');
                el.classList.add('markericon', 'fas', 'fa-map-marker-alt');

                new mapboxgl.Marker(el).setLngLat(marker.geometry.coordinates).addTo(map);
            });

            maps.push(map);
        });
    }
}
